import { ArrayDataSource } from '@angular/cdk/collections';
import { ChangeDetectionStrategy, Component, computed, EventEmitter, Input, input, Output } from '@angular/core';
import { SessionListDataSource } from '@go-modules/services/session-list-datasource/session-list.datasource';
import { GRID_CONSTANTS } from '@go-modules/components/grid-virtual-scroll-viewport/grid.constants';
import { Session as SessionModel } from 'go-modules/models/session/session.service';

@Component({
	selector: 'session-grid',
	templateUrl: './session-grid.component.html',
	styleUrls: ['./session-grid.component.scss'],
	changeDetection: ChangeDetectionStrategy.OnPush,
	standalone: false
})
export class SessionGridComponent {
	@Input() public submitMode: boolean = false;
	@Input() public allowSelection = true;
	@Input() public isSubmittingSessions = false;
	@Input() public selectedSessionIds: ReadonlySet<number> | null = null;
	@Output() public selectionToggled = new EventEmitter<any>();
	public minWidth: number = GRID_CONSTANTS.minWidth;
	public maxWidth: number = GRID_CONSTANTS.maxWidth;
	public minGap: number = GRID_CONSTANTS.minGap;
	@Output() public openSession = new EventEmitter();

	public readonly filteredSessions = input<ReturnType<typeof SessionModel>[]>();

	public readonly dataSource = computed(() => {
		const sessions = this.filteredSessions();
		return sessions ? new ArrayDataSource(sessions) : this.sessionListDataSource;
	});

	constructor (
		public sessionListDataSource: SessionListDataSource
	) {}

	public goToSession (session) {
		this.openSession.emit(session);
	}

	public isSessionSelected (session): boolean {
		return !!this.selectedSessionIds?.has(session.session_id);
	}

	public onSelectionToggle (session): void {
		this.selectionToggled.emit(session);
	}

	public getAriaSetSize (): number | null {
		const sessions = this.filteredSessions();
		return sessions?.length ?? this.sessionListDataSource.getCurrentTotalCount();
	}

	public getAriaPosInSet (rowIndex: number, itemIndex: number, columnCount: number): number {
		return (rowIndex * columnCount) + itemIndex + 1;
	}
}
